import { createSelector } from 'reselect';

import type { State } from 'reducers';

import type DonationSchedule from './model';

const sortDonationSchedules = (a: DonationSchedule, b: DonationSchedule) => {
  if (a.createdAt < b.createdAt) {
    return -1;
  } else if (a.createdAt > b.createdAt) {
    return 1;
  }

  return 0;
};

export const selectDonationScheduleState = (state: State) => state.get('entities').donationSchedule;

export const selectDonationSchedules = createSelector(
  selectDonationScheduleState,
  (donationScheduleState) => donationScheduleState.get('donationSchedules')
);

export const selectDonationSchedulesByUser = createSelector(
  selectDonationSchedules,
  (_state, userId: string) => userId,
  (donationSchedules, userId) =>
    donationSchedules
      .filter((donationSchedule) => donationSchedule?.user?.id === userId)
      .sort(sortDonationSchedules)
);

export const selectDonationScheduleById = createSelector(
  selectDonationSchedules,
  (_state, id: string): string => id,
  (donationSchedules, id) => donationSchedules.get(id)
);
